import AppUtils from '../../utils'


let dateFormat = date => {// 日期 年-月-日
  return AppUtils.formatDate(date);
};
let dateFormatToSecond = date => {//日期  年-月-日 时：分： 秒
  return AppUtils.formatDateToSecond(date);
};
let formatTime = str => {
  if (str !== "0" && str !== "" && str !== null) {
    return (Math.floor(str / 60)).toString() + "小时" + (str % 60).toString()+"分";
  } else {
    return "0";
  }
};
let orderState = state => {//工单状态
  const status = {
    0: "待派单",
    1: "待接单",
    2: "已接单",
    3: "待派单取消",
    4: "救援中",
    5: "扑空",
    6: "待跟进",
    7: "现场成功",
    8: "现场失败",
    9: "待跟进成功",
    10: "待跟进失败",
    11: "已接单取消",
    12: "救援中取消",
    13:"待抢单"
  };
  return status[state];
};
let rescuerTypeFilter = state => {
  const status = {
      1: "平台自营",
      2: "共享外拓",
      3: "渠道",
      4: "平台公用",
      5: "平台外拓",
  };
  return status[state];
};

let accidentLevel = state => {//事故等级
  const status = {
    0: "无价值事故",
    1: "小事故",
    2: "中等事故",
    3: "大事故",
    4: "特大事故",
  };
  return status[state];
};
let accidentDirection = state => {// 事故方向
  const status = {
    0: "南向北",
    1: "北向南",
    2: "东向西",
    3: "西向东",
    4: "进城",
    5: "出城",
  };
  return status[state];
};
let accidentState = state => {// 信息有效性
  const status = {
    0: "有效",
    1: "重复",
    2: "无效",
  };
  return status[state];
};
let accidentStates = state => {// 信息有效性
  const status = {
    1: "有效",
    2: "重复",
    3: "无效",
  };
  return status[state];
};

let accidentRoadType = state => {// 事故道路类型
  const status = {
    0: "主路",
    1: "辅路",
  };
  return status[state];
};
let accidentCarNum = state => {// 事故车辆数量
  const status = {
    0: "单车事故",
    1: "两车事故",
    2: "多车事故",
  };
  return status[state];
};

// 及时雨状态枚举
let timelyRainState = (state) => {
  const status = {
    0: "空闲",
    1: "离线",
    2: "忙碌",
    3: "暂离",
  };
  return status[state];
};

// 订单来源
let orderSourceState = state => {
  const status = {
    0: "微信群",
    1: "小程序",
    2: "现场补录",
  };
  return status[state];
};
let timeTypeState = state => {//白班 夜班
  const status = {
    0: "夜班",
    1: "白班",
   };
  return status[state];
};
//赔偿方式
let compensateState = state => {
  const status = {
    1: "直赔",
    2: "分赔",
    3: "垫付",
  };
  return status[state];
};
//性别称呼
let sexState = state => {
  const status = {
    1: "先生",
    0: "女士",
  };
  return status[state];
};
let msgStatus = state => {//工单状态
  const status = {
    0: "上传后未处理",
    1: "成功进入系统",
    2: "被过滤",
  };
  return status[state];
};
//责任划分
let dutyState = state => {
  const status = {
    1: "全责",
    2: "无责",
    3: "主要责任",
    4: "次要责任",
    5: "同等责任",
  };
  return status[state];
};
let callStatusFiter = state => {
  const status = {
      100: "未通话",
      102: "已通话",
      101: "未接通",
      300: "已完结",
  };
  return status[state];
}
//咨询类型
let communicateContentFiter = state => {
const status = {
  100: "故障咨询",
  200: "事故咨询",
  300: "销售咨询",
  400: "其他咨询",
  600: "出险报案",
};
return status[state];
}
// 距离单位 km
let distanceUnit = distance => {
  if(distance){
    return (distance/1000).toFixed(3) + ' km';
  }
  return '0km'
};

//价格
let priceUnit = price => {
  if(price|| price===0 ){
    return price + ' 元';
  }
};
//分钟
let minuteUnit = minute => {
  if(minute|| minute===0 ){
    return minute + '分钟';
  }
};
//秒
let secondUnit = second => {
  if(second|| second===0 ){
    return second + '秒';
  }
};




// 自保
let selfInsuranceState = state => {
  const status = {
    1: "是",
    0: "否",

  };
  return status[state];
};

let  carTypeState=state=>{
  const status = {
    1: "公车",
    0: "私车",

  };
  return status[state];
};

let  carNumberType=state=>{
  const status = {
    1: "蓝牌",
    2: "黄牌",
    3: "黑牌",
    4: "新能源",
    5: "使馆车",
    6: "港澳",
    7: "武警车",
    8: "新军牌",
    9: "领事馆",
    10: "无牌",
    11: "其他",
  };
  return status[state];
};


let redPayStates = state => {// 红包发送状态
  /*null/0 未发送
  1 发送成功
  2 发送失败
  9 补发成功*/
  const status = {
    null: "未发送",
    0: "未发送",
    1: "发送成功",
    2: "发送失败",
    9: "补发成功",
  };
  return status[state];
};

let rescuerFilter = state => {// 红包发送状态
  const status = {
    1: "平台自营",
    2: "共享外拓",
    3: "渠道",
    4: "平台公用",
    5: "平台外拓"
  };
  return status[state];
};
let grabStatus = state => {// 抢单状态
  const status = {
    1: "未抢单",
    2: "抢单中",
    3: "抢单成功",
    4: "抢单失败",
    5: "取消抢单",
  };
  return status[state];
};
let tagTypeArr = state => {
  const status = {
    100: "救援大师",
    200: "王者战士",
    300: "钻石战士",
    400: "黄金士兵",
  }
  return status[state]
}
export {
  communicateContentFiter,
  callStatusFiter,
  msgStatus,
  dateFormat,
  dateFormatToSecond,
  orderState,
  rescuerTypeFilter,
  accidentLevel,
  accidentDirection,
  accidentState,
  accidentStates,
  accidentRoadType,
  accidentCarNum,
  timelyRainState,
  orderSourceState,
  compensateState,
  dutyState,
  sexState,
  distanceUnit,
  priceUnit,
  selfInsuranceState,
  carTypeState,
  carNumberType,
  timeTypeState,
  minuteUnit,
  secondUnit,
  redPayStates,
  rescuerFilter,
  grabStatus,
  formatTime,
  tagTypeArr,
}



// WEBPACK FOOTER //
// ./src/assets/js/filter.js